<template>
  <div class="defaultLayout" :class="{ alert: alert }">
    <div class="demo-notice" role="status">{{ demoNotice }}</div>
    <in-header :class="{ isFixed : isFixed }" />
    <div class="container" ref="scrollTest">
      <in-nav />
      <in-main :currentMenu="currentMenu"/>
    </div>
    <PTApply></PTApply>
    <SubPointBuy></SubPointBuy>
    <loading></loading>
  </div>
</template>

<script>
import InHeader from '@/components/main/header'
import InNav from '@/components/main/Nav'
import InMain from '@/components/main/Main'
import Loading from '@/components/common/Loading.vue'

import PTApply from '@/components/common/PTApply.vue'
import SubPointBuy from '@/components/common/SubPointBuy.vue'
export default {
  name: 'DefaultLayout',
  components: {
    PTApply,
    SubPointBuy,
    InHeader,
    InNav,
    InMain,
    Loading
  },
  data () {
    return {
      demoNotice: 'PORTFOLIO DEMO · 샘플 데이터 / 조회 체험 전용 · 지급·회수·저장 불가',
      isFixed: false,
      menuList: [],
      currentMenu: {
        isActive: true,
        parent: {},
        child: {}
      }
    }
  },
  mounted() {
    window.addEventListener('demo-disabled', this.showDemoNotice)
    document.addEventListener('scroll', this.scroll)
  },
  beforeUnmount() {
    window.removeEventListener('demo-disabled', this.showDemoNotice)
    document.removeEventListener('scroll', this.scroll)
  },
  methods: {
    showDemoNotice (event) { this.demoNotice = event.detail },
    scroll () {
      if (window.scrollY > this.$refs.scrollTest.offsetTop) {
        this.isFixed = false
      } else {
        this.isFixed = false
      }
   }
  },
  async created () {
    await this.setGameList()
  }
}
</script>

<style scoped>
.demo-notice { position: fixed; bottom: 0; left: 0; right: 0; z-index: 9999; padding: 9px; text-align: center; background: #153d30; color: #e0ffee; font-size: 13px; }
.container {
  display: flex;
  height: 100%;
  width: 100%;
}
.alert {animation: blink .5s step-end infinite;}
@keyframes blink {
 0% {background-color: #ff9797;}
 50% {background-color: #f7bcbc;}
}
@-webkit-keyframes blink {
 0% {background-color: #ff9797;}
 50% {background-color: #f7bcbc;}
}

</style>
